<template>
  <div>
    <div class="container customContainer">
      <div class="row">
        <!-- breadcrumb start -->
        <div class="col-12">
          <base-breadcrumb :items="breadcrumbItems" :class-list-page="false" class="authorizationManagementbreadcrumb" />
        </div>
        <!-- breadcrumb end -->
      </div>
      <role-management
        ref="roleManagement"
        :selected-role-with-sub-model="selectedRoleWithSubModel"
        :arranged-categories="arrangedCategories"
        :filtered-roles-with-sub-models="filteredRolesWithSubModels"
        :selected-temp-id="selectedTempId"
        :chosen-roles-list="chosenRolesList"
        :is-not-selected-role="isNotSelectedRole"
        :selected-roles-to-be-added="selectedRolesToBeAdded"
        :selected-roles-to-be-removed="selectedRolesToBeRemoved"
        :selected-sources="selectedSources"
        :selected-sources-for-selected="selectedSourcesForSelected"
        :loading-btn-state="loadingBtnState"
        :publish-permission="publishPermission"
        :submit-for-approval-permission="submitForApprovalPermission"
        :cancel-permission="cancelPermission"
        :reject-permission="rejectPermission"
        :recall-permission="recallPermission"
        :delete-permission="deletePermission"
        :update-permission="updatePermission"
        :overlay-warning-message="warningMessage"
        :is-selected-role-status-waiting-approval="isSelectedRoleStatusWaitingApproval"
        @emitSelectRoleWithSubModel="selectRoleWithSubModel"
        @saveSelectedRoleWithSubModel="saveSelectedRoleWithSubModel()"
        @emitEntityNameFromEdit="setEntityNameAndOpenAddRoleModal"
        @resetSelectedFieldsByFieldNameList="resetSelectedFieldsByFieldNameList"
        @emitPublish="publish"
        @emitReject="reject"
        @emitRecall="recall"
        @emitCancel="cancel"
        @emitSubmitForApproval="submitForApproval"
        @emitUpdateSelectedEntity="updateSelectedEntity"
        @emitSaveChanges="openToSaveModal"
        @emitAddNewRole="newRole"
        @emitFilterSearchInputLowerCase="filteredSearchInputLowerCase = $event"
        @emitSetSelectedRolesToBeAdded="selectedRolesToBeAdded = $event"
        @emitSetSelectedRolesToBeRemoved="selectedRolesToBeRemoved = $event"
      />
    </div>

    <!-- create modal -->
    <div
      id="addRoleModal"
      class="modal fade staffModal"
      data-backdrop="static"
      data-keyboard="false"
      tabindex="-1"
      aria-labelledby="addRoleModal"
      aria-hidden="true"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <div class="container-fluid">
              <div class="row mt-sm-3">
                <div class="col-12">
                  <button type="button" class="close p-2" data-dismiss="modal" aria-label="Close" @click="closeAddRoleModal">
                    <span aria-hidden="true"><img src="../../../public/src/images/icon-modal-close.svg" alt="icon-modal-close" /></span>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-body">
            <validation-observer ref="observerRole" slim>
              <div class="container-fluid">
                <div class="row">
                  <div class="col-12">
                    <base-input
                      v-model="entityName"
                      :input-label-text="'Rol Adı'"
                      :rules="{ required: true }"
                      :custom-messages="{ required: 'Zorunlu alan' }"
                    />
                  </div>
                </div>
              </div>
            </validation-observer>
          </div>
          <div class="modal-footer mb-4">
            <div class="container-fluid">
              <div class="row">
                <div class="col-12 text-center">
                  <button type="button" class="btn btn-secondary" data-dismiss="modal" @click="closeAddRoleModal">İptal</button>
                  <button type="button" class="btn btn-primary" @click="addNewRole()">Kaydet</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- save Modal -->
    <div id="saveModal" class="modal fade modalDelete" tabindex="-1" aria-labelledby="saveModal" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <div class="container-fluid">
              <div class="row">
                <div class="col-12 mt-sm-3">
                  <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true"><img src="../../../public/src/images/icon-modal-close.svg" alt="icon-modal-close" /></span>
                  </button>
                </div>
                <div class="col-12 text-center">
                  <img src="../../../public/src/images/icon-modal-question.svg" alt="icon-modal-question" />
                  <h3 class="modal-title mt-2">Uyarı</h3>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-body">
            <div class="container-fluid">
              <div class="row justify-content-center">
                <div class="col-sm-10">
                  <p class="text-center">
                    {{ selectedRoleWithSubModel.name }} rolü için
                    {{ selectedRoleWithSubModel.resources ? selectedRoleWithSubModel.resources.length : "" }} yetki
                    {{ selectedRoleWithSubModel.resourceGroups.length }} adet yetki grubu ataması yapılacaktır.
                  </p>
                  <p class="text-center">Devam etmek istiyor musunuz?</p>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer mb-4">
            <div class="container-fluid">
              <div class="row">
                <div class="col-12 text-center">
                  <button type="button" class="btn btn-secondary" data-dismiss="modal">Hayır</button>
                  <button type="button" class="btn btn-primary" @click="save()">Evet</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- delete Modal -->
    <base-modal-component
      v-if="selectedRoleWithSubModel.name"
      :id="'deleteModal'"
      :btn-text="'Evet'"
      :image="'icon-modal-question.svg'"
      :header-text="'Rol'"
      :inner-text="selectedRoleWithSubModel.name"
      :entity-title="'bu rol kaydını'"
      :modal-text="'silmek istediğinize emin misiniz ?'"
      :spinner="loadingBtnState === 'deleteRole'"
      @deleteEntity="deleteRole()"
    />
    <base-alert />
    <loading :active.sync="loadingFullPage" :is-full-page="true" />
  </div>
</template>

<script>
import BaseAlert from "../../component/element/BaseAlert";
import ServiceResponseHelper from "../../mixins/serviceResponseHelper";
import BaseBreadcrumb from "../../component/element/breadcrumb/BaseBreadcrumb.vue";
import callBreadcrumb from "../../util/callBreadcrumb";
import Loading from "vue-loading-overlay";
import RoleManagement from "../../component/RoleManagement.vue";
import BaseInput from "../../component/element/form/input/BaseInput.vue";
import enumHelper from "../../util/enumHelper";
import moment from "moment";
import Vue from "vue";
import commonEntityProperties from "../../mixins/commonEntityProperties";
import BaseModalComponent from "../../component/modals/BaseModalComponent.vue";

export default {
  name: "AuthorizationManagement",
  components: { BaseModalComponent, BaseInput, RoleManagement, Loading, BaseBreadcrumb, BaseAlert },
  mixins: [ServiceResponseHelper, commonEntityProperties],
  data() {
    return {
      selectedRoleWithSubModel: { name: "", resources: [], resourceGroups: [] },
      arrangedCategories: [],
      selectedSources: [],
      selectedSourcesForSelected: [],
      breadcrumbItems: callBreadcrumb.authorizationManagementCreateView,
      selectedTempId: null,
      chosenRolesList: [],
      selectedRolesToBeAdded: [],
      selectedRolesToBeRemoved: [],
      arrangedCategoryGroups: [],
      loadRolesWithSubModelsLoading: false,
      loadResourcesWithAllCategoriesTreeLoading: false,
      loadPublishedResourceGroupsLoading: false,
      loadingSave: false,
      loadingRole: false,
      loadingDraftRole: false,
      selectedGroupSources: [],
      chosenCategoryGroups: [],
      selectedRoleGroupsToBeAdded: [],
      selectedRoleGroupsToBeRemoved: [],
      isNotSelectedRole: true,
      overlayWarningMessage: "Lütfen önce rol adı seçiniz.",
      entityName: null,
      loadingBtnState: "",
      loadingPublishSelectedRoleWithSubModel: false,
      loadingSendToApproval: false,
      loading: false,
      warningMessages: {
        WAITING_APPROVAL: "Bu rol onay beklemektedir.",
        OTHER: "Lütfen önce rol adı seçiniz.",
      },
      filteredSearchInputLowerCase: "",
      initialSelectedRoleWithSubModel: { name: "", resources: [], resourceGroups: [] },
    };
  },
  computed: {
    loadingFullPage() {
      return (
        this.loading ||
        this.loadingPublishSelectedRoleWithSubModel ||
        this.loadRolesWithSubModelsLoading ||
        this.loadResourcesWithAllCategoriesTreeLoading ||
        this.loadPublishedResourceGroupsLoading ||
        this.loadingRole ||
        this.loadingSave ||
        this.loadingDraftRole ||
        this.loadingSendToApproval
      );
    },
    rolesWithSubModels: {
      get() {
        return this.$store.getters.getRolesWithSubModels;
      },
      set(val) {
        this.$store.commit("setRolesWithSubModels", val);
      },
    },
    resourcesWithAllCategoriesTree: {
      get() {
        return this.$store.getters.getResourcesWithAllCategoriesTree;
      },
      set(val) {
        this.$store.commit("setResourcesWithAllCategoriesTree", val);
      },
    },
    isSelectedRoleStatusWaitingApproval() {
      return this.getEntityStatusForPermission(this.selectedRoleWithSubModel) === "WAITING_APPROVAL";
    },
    warningMessage() {
      return this.isSelectedRoleStatusWaitingApproval ? this.warningMessages.WAITING_APPROVAL : this.warningMessages.OTHER;
    },
    filteredRolesWithSubModels() {
      return this.rolesWithSubModels.filter((role) => {
        return role.name.toLocaleLowerCase("tr-TR").includes(this.filteredSearchInputLowerCase);
      });
    },
  },
  created() {
    this.fetchRoles();
  },
  mounted() {
    this.treeViewToggleElement();
  },
  methods: {
    // Seçilen rolleri ekler
    mergeResourcesForConvertFromRoleToChooseList(categories, resources) {
      function processCategory(category) {
        // Alt kategorileri işle
        if (category.subCategory && category.subCategory.length > 0) {
          category.subCategory = category.subCategory
            .map((subCategory) => processCategory(subCategory))
            .filter((subCategory) => subCategory.resources.length > 0 || subCategory.subCategory.length > 0);
        }

        // Kategorinin altındaki kaynakları filtrele
        if (category.resources && category.resources.length > 0) {
          category.resources = category.resources.filter((resource) => resources.some((r) => r.id === resource.id));
        }

        return category;
      }

      // Kategorileri işle
      categories = categories
        .map((category) => processCategory(category))
        .filter((category) => category.resources.length > 0 || category.subCategory.length > 0);

      return categories;
    },
    addChosenRoleUpdate() {
      this.selectedRolesToBeAdded.forEach((mainCategory) => {
        const existingMainCategory = this.chosenRolesList.find((role) => role.id === mainCategory.id);

        if (!existingMainCategory) {
          this.chosenRolesList.push(JSON.parse(JSON.stringify(mainCategory)));
        } else {
          const newResources = mainCategory.resources.filter(
            (resource) => !existingMainCategory.resources.some((existingResource) => existingResource.id === resource.id)
          );

          existingMainCategory.resources.push(...newResources);
        }
      });

      this.$nextTick(() => {
        this.selectedRolesToBeAdded = [];
        this.selectedRolesToBeRemoved = [];
        this.selectedSources = [];
      });

      this.selectedRoleGroupsToBeAdded.forEach((group) => {
        if (!this.chosenCategoryGroups.some((chosenGroup) => chosenGroup.id === group.id)) {
          this.chosenCategoryGroups.push(JSON.parse(JSON.stringify(group)));
        }
      });

      this.$nextTick(() => {
        this.selectedGroupSources = [];
        this.selectedRoleGroupsToBeAdded = [];
        this.selectedRoleGroupsToBeRemoved = [];
      });
    },
    selectRoleWithSubModel(role) {
      this.resetSelectedDatas();
      this.chosenRolesList = [];
      this.selectedTempId = role.tempId;
      role.resourceGroups = [];
      this.selectedRoleWithSubModel = role;
      this.initialSelectedRoleWithSubModel = JSON.parse(JSON.stringify(this.selectedRoleWithSubModel));
      this.selectedSources = JSON.parse(JSON.stringify(role.resources));
      this.isNotSelectedRole = false;
      const isItCreateEntity = !role.id && !role.intentId && !role.intents;
      if (this.getEntityStatusForPermission(role) === "WAITING_APPROVAL" || isItCreateEntity) {
        this.defineEntityProperties(role);
        return;
      }

      let selectedId;
      if (!this.selectedRoleWithSubModel.id && !this.selectedRoleWithSubModel.intentId && !this.selectedRoleWithSubModel.intents) {
        return;
      }
      if (this.selectedRoleWithSubModel.id !== 0) {
        selectedId = this.selectedRoleWithSubModel.id;
        this.loadingRole = true;
        this.$store
          .dispatch("loadRole", { id: selectedId })
          .then((response) => {
            this.loadingRole = false;
            response.tempId = this.selectedRoleWithSubModel.tempId;
            this.selectedRoleWithSubModel = response;
            this.selectedRoleWithSubModel.resourceGroups = response.resourceGroups;
            this.selectedRoleWithSubModel.resources = response.resources;
            this.initialSelectedRoleWithSubModel = JSON.parse(JSON.stringify(this.selectedRoleWithSubModel));
            this.selectedSources = JSON.parse(JSON.stringify(response.resources));
            // update
            this.selectedRoleUpdate();
            this.defineEntityProperties(this.selectedRoleWithSubModel);
          })
          .catch(() => {
            this.loadingRole = false;
            this.callAlert(4, "İşlem gerçekleştirilememektedir.", "danger", "İşlem Hatası");
          })
          .finally(() => {
            this.loadingRole = false;
          });
      } else {
        selectedId = this.selectedRoleWithSubModel.intentId;
        this.loadingDraftRole = true;
        this.$store
          .dispatch("loadDraftRole", selectedId)
          .then((response) => {
            this.loadingDraftRole = false;
            response.tempId = this.selectedRoleWithSubModel.tempId;
            this.selectedRoleWithSubModel = response;
            this.selectedRoleWithSubModel.resourceGroups = response.resourceGroups;
            this.selectedRoleWithSubModel.resources = response.resources;
            this.initialSelectedRoleWithSubModel = JSON.parse(JSON.stringify(this.selectedRoleWithSubModel));
            this.selectedSources = JSON.parse(JSON.stringify(response.resources));
            // update
            this.selectedRoleUpdate();
            let foundIndex = this.rolesWithSubModels.findIndex((role) => role.tempId === this.selectedRoleWithSubModel.tempId);
            this.defineEntityProperties(this.rolesWithSubModels[foundIndex]);
          })
          .catch(() => {
            this.loadingDraftRole = false;
            this.callAlert(4, "İşlem gerçekleştirilememektedir.", "danger", "İşlem Hatası");
          })
          .finally(() => {
            this.loadingDraftRole = false;
          });
        // alert("Draft orers temporary inactive.");
        //TODO:Draft modeller için get isteği yazılacak. (id'leri yok)
      }
    },
    treeViewToggleElement() {
      let togglerMainHead = document.querySelectorAll(".treeViewSidebar .mainUl .mainHead");

      for (let i = 0; i < togglerMainHead.length; i++) {
        togglerMainHead[i].addEventListener("click", function () {
          this.parentElement.parentElement.parentElement.querySelector(".subUl").classList.toggle("active");

          this.classList.toggle("mainHeadOpen");

          // // tıkladığım öge bg color ekliyor.
          $(".mainUl li .row.colArea .col.d-flex").removeClass("mainHeadOpenClick");
          this.parentElement.classList.add("mainHeadOpenClick");
        });
      }
    },
    arrangeResourceWithCategoriesV2() {
      const categoryMap = new Map();

      this.resourcesWithAllCategoriesTree.forEach((category) => {
        const parentId = category.parentId;

        if (category.resources.length === 0) return;
        if (categoryMap.has(parentId)) {
          categoryMap.get(parentId).push(category);
        } else {
          categoryMap.set(parentId, [category]);
        }
      });

      // return categoryMap;
      return Array.from(categoryMap.values());
    },
    saveSelectedRoleWithSubModel() {
      // chosenRolesList içindeki tüm kaynakları düzleştir
      const allResources = this.flattenResources(this.chosenRolesList);

      // chosenCategoryGroups içindeki tüm alt kategori kaynaklarını düzleştir
      const allGroupResources = this.flattenGroupResources(this.chosenCategoryGroups);

      this.selectedRoleWithSubModel.resources = allResources;
      this.selectedRoleWithSubModel.resourceGroups = allGroupResources;

      // Eğer chosenRolesList ve chosenCategoryGroups boşsa, seçilen kaynakları ve grupları temizle
      if (this.chosenRolesList.length === 0) {
        this.selectedRoleWithSubModel.resources = [];
      }
      if (this.chosenCategoryGroups.length === 0) {
        this.selectedRoleWithSubModel.resourceGroups = [];
      }
    },
    flattenResources(categories) {
      return categories.reduce((acc, category) => {
        acc.push(...category.resources);
        if (category.subCategory.length > 0) {
          acc.push(...this.flattenResources(category.subCategory));
        }
        return acc;
      }, []);
    },
    flattenGroupResources(groups) {
      return groups.reduce((acc, group) => {
        if (group.resources && Array.isArray(group.resources)) {
          acc.push(...group.resources);
        }
        return acc;
      }, []);
    },
    selectedRoleUpdate() {
      let copySelectedResources = JSON.parse(JSON.stringify(this.selectedSources));

      let resultForSelectedRolesToBeAdded = this.mergeResourcesForConvertFromRoleToChooseList(
        JSON.parse(JSON.stringify(this.arrangedCategories)),
        copySelectedResources
      );
      this.selectedRolesToBeAdded = JSON.parse(JSON.stringify(resultForSelectedRolesToBeAdded));
      this.addChosenRoleUpdate();
      this.selectedGroupSources = JSON.parse(JSON.stringify(this.selectedRoleWithSubModel.resourceGroups));

      this.selectedGroupSources.forEach((category) => {
        const selectedCategoryGroupResource = this.arrangedCategoryGroups.filter((resource) => resource.id === category.id);
        this.selectedRoleGroupsToBeAdded.push(...selectedCategoryGroupResource);
        this.selectedRoleGroupsToBeRemoved.push(...selectedCategoryGroupResource);
      });

      this.addChosenRoleUpdate();
    },
    triggerCheckCategoryChangeEvent(category) {
      // Burada checkCategoryChangeEvent fonksiyonunu çağırabilirsiniz
      this.checkCategoryChangeEvent(category, categoryIndex, $event);
      if (category.subCategory && category.subCategory.length > 0) {
        category.subCategory.forEach((subCategory) => {
          this.triggerCheckCategoryChangeEvent(subCategory); // Alt kategoriler için de aynı işlemi yap
        });
      }
    },
    resetSelectedFieldsByFieldNameList(fieldNameList) {
      fieldNameList.forEach((fieldName) => {
        this[fieldName] = [];
      });
    },
    addNewRole() {
      this.$refs.observerRole.validate().then((success) => {
        if (success) {
          if (!this.selectedRoleWithSubModel.id && !this.selectedRoleWithSubModel.intentId && !this.selectedRoleWithSubModel.intents) {
            this.selectedRoleWithSubModel.name = this.entityName;
            this.selectedRoleWithSubModel.tempId = this.idGenerator();
            // this.filteredRolesWithSubModels.push(this.selectedRoleWithSubModel);
            this.rolesWithSubModels.push(this.selectedRoleWithSubModel);
            this.resetSelectedDatas();
            this.saveSelectedRoleWithSubModel();

            const findCheckInputIndex = this.rolesWithSubModels.findIndex(
              (rolesWithSubModel) => rolesWithSubModel.tempId === this.selectedRoleWithSubModel.tempId
            );
            this.$nextTick(() => {
              document
                .querySelector("#scrollRoleWithSubModel" + this.selectedRoleWithSubModel.id + findCheckInputIndex)
                .querySelector(".btnRole")
                .click();
            });
          } else {
            const findCheckInputIndex = this.rolesWithSubModels.findIndex(
              (rolesWithSubModel) => rolesWithSubModel.tempId === this.selectedRoleWithSubModel.tempId
            );
            this.rolesWithSubModels[findCheckInputIndex].name = this.entityName;
            this.selectedRoleWithSubModel.name = this.entityName;
          }
          this.$refs.observerRole.reset();
          $("#addRoleModal").modal("hide");
        }
      });
    },
    closeAddRoleModal() {
      this.entityName = null;
      this.$refs.observerRole.reset();
    },
    setEntityNameAndOpenAddRoleModal(event) {
      this.selectRoleWithSubModel(event);
      this.entityName = event.name;
      $("#addRoleModal").modal("show");
    },
    async fetchRoles() {
      // Tüm işlemleri Promise.all ile takip edeceğiz
      return new Promise((resolve, reject) => {
        this.resetSelectedDatas();
        // Başlangıçta yükleme bayraklarını true yapıyoruz
        this.loadRolesWithSubModelsLoading = true;
        this.loadResourcesWithAllCategoriesTreeLoading = true;
        this.loadPublishedResourceGroupsLoading = true;

        // İşlem 1: loadRolesWithSubModels
        this.$store
          .dispatch("loadRoles")
          .then((responseRolesWithSubModels) => {
            responseRolesWithSubModels.forEach((entity) => {
              entity.tempId = this.idGenerator();
            });
            // İşlem 2: loadResourcesWithAllCategoriesTree
            return this.$store.dispatch("loadResourcesWithAllCategoriesTree").then(() => {
              this.arrangedCategories = this.arrangeResourceWithCategoriesV2();
              let newCategory = [];
              newCategory = this.arrangedCategories.flat();
              this.arrangedCategories = newCategory;

              // Verileri güncelliyoruz
              this.rolesWithSubModels = responseRolesWithSubModels;
              this.filteredSearchInputLowerCase = "";
            });
          })
          .then(() => {
            // İşlem 3: loadPublishedResourceGroups
            return this.$store.dispatch("loadPublishedResourceGroups").then((response) => {
              Vue.set(this, "arrangedCategoryGroups", response);
            });
          })
          .then(() => {
            // Tüm işlemler tamamlandığında bayrakları false yapıyoruz
            this.loadRolesWithSubModelsLoading = false;
            this.loadResourcesWithAllCategoriesTreeLoading = false;
            this.loadPublishedResourceGroupsLoading = false;

            // Tüm işlemler tamamlandı, resolve ediyoruz
            resolve();
          })
          .catch((error) => {
            // Bir hata oluşursa bayrakları false yapıyoruz ve reject ediyoruz
            this.loadRolesWithSubModelsLoading = false;
            this.loadResourcesWithAllCategoriesTreeLoading = false;
            this.loadPublishedResourceGroupsLoading = false;

            reject(error);
          });
      });
    },
    submitForApproval() {
      this.filteredSearchInputLowerCase = "";
      if (this.submitForApprovalPermission === false) return;
      this.loadingBtnState = "submitForApproval";
      this.loadingSendToApproval = true;
      let foundRole = this.rolesWithSubModels.find((role) => role.tempId === this.selectedRoleWithSubModel.tempId);
      let request = JSON.parse(JSON.stringify(foundRole));
      this.$store
        .dispatch("sendToApprovalRoles", request)
        .then(async (response) => {
          this.loadingSendToApproval = false;
          this.callAlert(
            4,
            this.getAlertTextForCRUD(enumHelper.MyPages.ROLE.replace(" Yönetimi", ""), foundRole.name, "send_for_approval"),
            "success",
            "Başarılı"
          );
          try {
            await this.fetchRoles();
            let findCheckInputIndex = this.rolesWithSubModels.findIndex(
              (rolesWithSubModel) => rolesWithSubModel.intentId === this.selectedRoleWithSubModel.intentId
            );
            document
              .querySelector("#scrollRoleWithSubModel" + this.selectedRoleWithSubModel.id + findCheckInputIndex)
              .querySelector(".btnRole")
              .click();
          } catch (error) {
            this.loadingSendToApproval = false;
            console.error(error);
          }
        })
        .finally(() => {
          this.loadingSendToApproval = false;
          this.loadingBtnState = null;
        });
    },
    openToSaveModal() {
      this.filteredSearchInputLowerCase = "";
      this.saveSelectedRoleWithSubModel();
      if (this.selectedRoleWithSubModel.resources.length === 0 && this.selectedRoleWithSubModel.resourceGroups.length === 0) {
        this.callAlert(4, "En az bir tane yetki adı veya yetki grubu seçilmelidir.", "danger", "Başarısız");
      } else if (!this.hasRoleDifference()) {
        this.callAlert(4, "Herhangi bir değişiklik algılanmadı.", "warning", "Başarısız");
      } else {
        $("#saveModal").modal("show");
      }
    },
    save() {
      if (this.selectedRoleWithSubModel.intents !== undefined && this.selectedRoleWithSubModel.intents !== null) {
        if (this.selectedRoleWithSubModel.intents[0].type !== enumHelper.ROLE.CREATE || this.selectedRoleWithSubModel.intents[0].status !== "DRAFT") {
          this.selectedRoleWithSubModel.intentId = 0;
        }
      }
      delete this.selectedRoleWithSubModel.intents;
      this.loadingSave = true;
      this.$store
        .dispatch("createRole", this.selectedRoleWithSubModel)
        .then(async (response) => {
          if (response.status === 200) {
            $("#saveModal").modal("hide");
            this.callAlert(
              4,
              this.getAlertTextForCRUD(
                this.enumHelper.MyPages.ROLE.replace(" Yönetimi", ""),
                this.selectedRoleWithSubModel.name,
                this.selectedRoleWithSubModel.id === undefined ? "create" : "update"
              ),
              "success",
              "Başarılı"
            );
            await this.fetchRoles();
            let findCheckInputIndex = this.rolesWithSubModels.findIndex((rolesWithSubModel) => rolesWithSubModel.intentId === response.data.intentId);
            document
              .querySelector("#scrollRoleWithSubModel" + response.data.id + findCheckInputIndex)
              .querySelector(".btnRole")
              .click();
          } else {
            this.errorResponse(response);
          }
        })
        .finally(() => {
          this.loadingSave = false;
        });
    },
    publish() {
      this.filteredSearchInputLowerCase = "";
      if (this.publishPermission === false) return;
      this.loadingPublishSelectedRoleWithSubModel = true;
      let request = JSON.parse(JSON.stringify(this.selectedRoleWithSubModel));
      this.loadingBtnState = "publish";
      this.$store
        .dispatch("publishRole", request)
        .then(async (response) => {
          this.loadingPublishSelectedRoleWithSubModel = false;
          if (this.selectedRoleWithSubModel.intents) {
            if (this.selectedRoleWithSubModel.intents[0].type === "DELETE_ROLE") {
              this.callAlert(
                4,
                this.getAlertTextForCRUD(enumHelper.MyPages.ROLE.replace(" Yönetimi", ""), this.selectedRoleWithSubModel.name, "publish", "DELETE"),
                "success",
                "Yayınlandı"
              );
              this.resetSelectedDatas();
            } else {
              this.callAlert(
                4,
                this.getAlertTextForCRUD(enumHelper.MyPages.ROLE.replace(" Yönetimi", ""), this.selectedRoleWithSubModel.name, "publish", "PUBLISH"),
                "success",
                "Yayınlandı"
              );
            }
          }
          if (this.selectedRoleWithSubModel.intents[0].type === "DELETE_ROLE") {
            await this.fetchRoles();
            this.resetSelectedRoleWithSubModelAndDefineEntityProperties();
          } else {
            response.tempId = this.selectedRoleWithSubModel.tempId;
            this.selectedRoleWithSubModel = response;
            this.initialSelectedRoleWithSubModel = JSON.parse(JSON.stringify(this.selectedRoleWithSubModel));
            try {
              await this.fetchRoles();
              if (response) {
                let findCheckInputIndex = this.rolesWithSubModels.findIndex((rolesWithSubModel) => rolesWithSubModel.id === this.selectedRoleWithSubModel.id);
                document
                  .querySelector("#scrollRoleWithSubModel" + this.selectedRoleWithSubModel.id + findCheckInputIndex)
                  .querySelector(".btnRole")
                  .click();
              }
            } catch (error) {
              this.loading = false;
              console.error(error);
            }
          }
        })
        .catch((error) => {
          this.loadingPublishSelectedRoleWithSubModel = false;
          if (error.response.data.code === 1006) {
            this.callAlert(4, error.response.data.message, "danger", "Çakışan fiyatlandırma.", "danger");
          }
        })
        .finally(() => {
          this.loadingBtnState = null;
          this.loadingPublishSelectedRoleWithSubModel = false;
        });
    },
    reject() {
      this.filteredSearchInputLowerCase = "";
      if (this.rejectPermission === false) {
        return;
      }
      this.loadingBtnState = "reject";
      let request = JSON.parse(JSON.stringify(this.selectedRoleWithSubModel));
      this.$store
        .dispatch("rejectRole", request)
        .then(async (response) => {
          this.loadingBtnState = null;
          this.callAlert(
            4,
            this.getAlertTextForCRUD(enumHelper.MyPages.ROLE.replace(" Yönetimi", ""), this.selectedRoleWithSubModel.name, "reject", "reject"),
            "success",
            "Başarılı"
          );
          try {
            await this.fetchRoles();
            if (this.selectedRoleWithSubModel.intents[0].type === "DELETE_ROLE") {
              let findCheckInputIndex = this.rolesWithSubModels.findIndex((rolesWithSubModel) => rolesWithSubModel.id === this.selectedRoleWithSubModel.id);
              document
                .querySelector("#scrollRoleWithSubModel" + this.selectedRoleWithSubModel.id + findCheckInputIndex)
                .querySelector(".btnRole")
                .click();
            } else {
              let findCheckInputIndex = this.rolesWithSubModels.findIndex(
                (rolesWithSubModel) => rolesWithSubModel.intentId === this.selectedRoleWithSubModel.intentId
              );
              document
                .querySelector("#scrollRoleWithSubModel" + this.selectedRoleWithSubModel.id + findCheckInputIndex)
                .querySelector(".btnRole")
                .click();
            }
          } catch (error) {
            this.loadingBtnState = null;
            console.error(error);
          }
        })
        .finally(() => {
          this.loadingBtnState = null;
        });
    },
    recall() {
      this.filteredSearchInputLowerCase = "";
      if (this.recallPermission === false) return;
      this.loadingBtnState = "recall";
      let request = JSON.parse(JSON.stringify(this.selectedRoleWithSubModel));
      this.$store
        .dispatch("recallRole", request)
        .then(async (response) => {
          this.loadingBtnState = null;
          //TODO:istek hatalı
          this.callAlert(
            4,
            this.getAlertTextForCRUD(enumHelper.MyPages.ROLE.replace(" Yönetimi", ""), this.selectedRoleWithSubModel.name, "recall"),
            "success",
            "Başarılı"
          );
          try {
            this.loading = true;
            await this.fetchRoles();
            this.loading = false;
            if (this.selectedRoleWithSubModel.intents[0].type === "DELETE_ROLE") {
              let findCheckInputIndex = this.rolesWithSubModels.findIndex((rolesWithSubModel) => rolesWithSubModel.id === this.selectedRoleWithSubModel.id);
              document
                .querySelector("#scrollRoleWithSubModel" + this.selectedRoleWithSubModel.id + findCheckInputIndex)
                .querySelector(".btnRole")
                .click();
            } else {
              let findCheckInputIndex = this.rolesWithSubModels.findIndex(
                (rolesWithSubModel) => rolesWithSubModel.intentId === this.selectedRoleWithSubModel.intentId
              );
              document
                .querySelector("#scrollRoleWithSubModel" + this.selectedRoleWithSubModel.id + findCheckInputIndex)
                .querySelector(".btnRole")
                .click();
            }
          } catch (error) {
            this.loadingBtnState = null;
            console.error(error);
          }
        })
        .finally(() => {
          this.loadingBtnState = null;
        });
    },
    cancel() {
      this.filteredSearchInputLowerCase = "";
      if (this.cancelPermission === false) return;
      this.loadingBtnState = "cancel";
      let request = JSON.parse(JSON.stringify(this.selectedRoleWithSubModel));
      this.$store
        .dispatch("cancelRole", request)
        .then(async (response) => {
          this.loadingBtnState = null;
          //TODO:istek hatalı
          this.callAlert(
            4,
            this.getAlertTextForCRUD(enumHelper.MyPages.ROLE.replace(" Yönetimi", ""), this.selectedRoleWithSubModel.name, "cancel"),
            "success",
            "Başarılı"
          );
          try {
            this.loading = true;
            await this.fetchRoles();
            this.loading = false;

            //eğer create durumda iptal edilirse seçili olanı sıfırla
            if (response.status === "CANCELLED" && response.type.startsWith("CREATE")) {
              this.resetSelectedRoleWithSubModelAndDefineEntityProperties();
            } else {
              let findCheckInputIndex = this.rolesWithSubModels.findIndex((rolesWithSubModel) => rolesWithSubModel.id === this.selectedRoleWithSubModel.id);
              document
                .querySelector("#scrollRoleWithSubModel" + this.selectedRoleWithSubModel.id + findCheckInputIndex)
                .querySelector(".btnRole")
                .click();
            }
          } catch (error) {
            this.loadingBtnState = null;
            console.error(error);
          }
        })
        .finally(() => {
          this.loadingBtnState = null;
        });
    },
    deleteRole() {
      this.filteredSearchInputLowerCase = "";
      this.$refs.roleManagement.filterSearchInput = "";
      if (this.selectedRoleWithSubModel.intentId && this.selectedRoleWithSubModel.intentId > 0 && !this.selectedRoleWithSubModel.id) {
        if (this.deleteDraftPermission === false) {
          return;
        }
        this.loadingBtnState = "deleteRole";
        this.$store
          .dispatch("deleteDraftRole", this.selectedRoleWithSubModel)
          .then(async (response) => {
            if (response === "warning") {
              $("#warningModal").modal();
            } else if (response.status === 200 && response.data === "") {
              this.callAlert(4, "Rol kaydı silindi.", "success", "Silme İşlemi");
              await this.fetchRoles();
              this.resetSelectedRoleWithSubModelAndDefineEntityProperties();
            }
          })
          .finally(() => {
            this.loadingBtnState = null;
          });
      } else {
        if (this.deletePermission === false) {
          return;
        }
        this.loadingBtnState = "deleteRole";
        this.$store
          .dispatch("deleteRole", this.selectedRoleWithSubModel)
          .then((response) => {
            this.selectedRoleWithSubModel = response;
            this.initialSelectedRoleWithSubModel = JSON.parse(JSON.stringify(this.selectedRoleWithSubModel));
            if (response) {
              let findCheckInputIndex = this.rolesWithSubModels.findIndex((rolesWithSubModel) => rolesWithSubModel.id === this.selectedRoleWithSubModel.id);
              document
                .querySelector("#scrollRoleWithSubModel" + this.selectedRoleWithSubModel.id + findCheckInputIndex)
                .querySelector(".btnRole")
                .click();
            }
            this.callAlert(4, "Rol kaydı için silme isteği gönderildi.", "success", "Silme İsteği Gönderildi");
          })
          .finally(() => {
            this.loadingBtnState = null;
          });
      }
    },
    updateSelectedEntity() {
      this.filteredSearchInputLowerCase = "";
      let selectedId;
      if (this.selectedRoleWithSubModel.id !== 0) {
        selectedId = this.selectedRoleWithSubModel.id;
        this.loadingRole = true;
        this.$store
          .dispatch("loadRole", { id: selectedId })
          .then((response) => {
            this.loadingRole = false;
            response.tempId = this.selectedRoleWithSubModel.tempId;
            this.selectedRoleWithSubModel = response;
            this.initialSelectedRoleWithSubModel = JSON.parse(JSON.stringify(this.selectedRoleWithSubModel));
          })
          .catch(() => {
            this.loadingRole = false;
            this.callAlert(4, "İşlem gerçekleştirilememektedir.", "danger", "İşlem Hatası");
          })
          .finally(() => {
            this.loadingRole = false;
          });
      } else {
        selectedId = this.selectedRoleWithSubModel.intentId;
        this.loadingDraftRole = true;
        this.$store
          .dispatch("loadDraftRole", selectedId)
          .then((response) => {
            this.loadingDraftRole = false;
            response.tempId = this.selectedRoleWithSubModel.tempId;
            this.selectedRoleWithSubModel = response;
            this.initialSelectedRoleWithSubModel = JSON.parse(JSON.stringify(this.selectedRoleWithSubModel));
          })
          .catch(() => {
            this.loadingDraftRole = false;
            this.callAlert(4, "İşlem gerçekleştirilememektedir.", "danger", "İşlem Hatası");
          })
          .finally(() => {
            this.loadingDraftRole = false;
          });
        // alert("Draft orers temporary inactive.");
        //TODO:Draft modeller için get isteği yazılacak. (id'leri yok)
      }
    },
    idGenerator() {
      return Math.random().toString(36).substr(2, 9);
    },
    newRole() {
      this.entityName = null;
      this.resetSelectedRoleWithSubModelAndDefineEntityProperties();
      $("#addRoleModal").modal("show");
    },
    resetSelectedDatas() {
      this.selectedRolesToBeAdded = [];
      this.selectedRolesToBeRemoved = [];
      this.selectedSources = [];
      this.selectedGroupSources = [];
      this.chosenRolesList = [];
      this.selectedSourcesForSelected = [];
      this.chosenCategoryGroups = [];
      this.selectedRoleGroupsToBeAdded = [];
      this.selectedRoleGroupsToBeRemoved = [];
    },
    resetSelectedRoleWithSubModelAndDefineEntityProperties() {
      this.selectedRoleWithSubModel = { name: "", resources: [], resourceGroups: [] };
      this.initialSelectedRoleWithSubModel = JSON.parse(JSON.stringify(this.selectedRoleWithSubModel));
      this.defineEntityProperties(this.selectedRoleWithSubModel);
      this.isNotSelectedRole = true;
    },
    deepSort(obj) {
      if (Array.isArray(obj)) {
        // Eğer dizi ise, içindeki elemanları sıralıyoruz.
        return obj
          .map(this.deepSort) // Dizideki her bir öğeyi sıralamak için deepSort'u çağır.
          .sort((a, b) => {
            if (a.id && b.id) {
              return a.id - b.id; // Eğer öğelerde 'id' varsa, ona göre sıralar.
            }
            return 0; // 'id' yoksa sıralama yapma.
          });
      } else if (obj && typeof obj === "object") {
        // Eğer nesne ise, anahtarları sıralıyoruz.
        const sortedObj = {};
        const keys = Object.keys(obj).sort(); // Anahtarları sıralar.
        keys.forEach((key) => {
          sortedObj[key] = this.deepSort(obj[key]); // Her anahtarın değerini deepSort ile sırala.
        });
        return sortedObj;
      }
      return obj; // Eğer ne dizi ne de nesne ise olduğu gibi geri döner.
    },
    hasRoleDifference() {
      const sortedJson1 = this.deepSort(JSON.parse(JSON.stringify(this.selectedRoleWithSubModel)));
      const sortedJson2 = this.deepSort(JSON.parse(JSON.stringify(this.initialSelectedRoleWithSubModel)));
      return JSON.stringify(sortedJson1) !== JSON.stringify(sortedJson2);
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep {
  .kilometricBasedPricing {
    .kilometricBasedPricingWorkFlowControlBox {
      -ms-flex-direction: row !important;
      flex-direction: row !important;

      li {
        -ms-flex: 1 1 auto !important;
        flex: 1 1 auto !important;

        .nav-link {
          border: 1px solid var(--light-periwinkle-two);
        }
      }

      .nav-item:nth-last-child(1) .nav-link {
        border-bottom: 1px solid var(--light-periwinkle-two);
      }
    }
  }
}
</style>
